export const enum SessionStorageVariables {
  PreviousPath = 'PREVIOUS_PATH',
  CurrentPath = 'CURRENT_PATH',
}
